module.exports = __webpack_public_path__ + "img/partner_logo12.673129d9.png";